module.exports = __webpack_public_path__ + "static/img/desktop-htgl.0dc01295.png";